import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IStyleProps } from "./interfaces";

export const ScoreWrapper = styled.div<IStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: 480px;
    ${p => p.isEaster && css`
        margin-top: 115px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 33px;
        height: calc(100% - 60px - 130px - 122px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 270px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 64px;
    left: 4px;
    right: -6px;
    bottom: 140px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${115 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${198 - padding}px;
    z-index: -1;
`;

export const RhytLadderWrapper = styled.div<IStyleProps>`
    ${p =>
        !p.isLow
            ? css`
                  padding: 44px;
                  transform: scale(1.2);
              `
            : css`
                  margin-top: 15px;
                  transform: scale(0.84);
              `}
    &.Completed {
        opacity: 0.4;
        pointer-events: none;
        transition: opacity 2s;
    }
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: -4px;
    left: 298px;
    pointer-events: none;

    img {
        width: 440px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    top: 115px;
    right: 0;
    pointer-events: none;
    img {
        width: 440px;
    }
`;

export const Asset3Wrapper = styled.div`
    position: absolute;
    top: 64px;
    left: -2px;
    pointer-events: none;
    img {
        width: 340px;
    }
`;
